import { Layout } from 'antd';
import NavBar from "../../components/NavBar";
import MapItemDetail from "../../components/map/MapItemDetail";

const { Content } = Layout;

function MapItem() {
   return (
      <Layout className="container main-layout">
         <NavBar />
         <Layout className="bg-gray">  
            <Content className="layout-content">
               <MapItemDetail/>
            </Content>
         </Layout>
      </Layout>
   );
}

export default MapItem;
